import { Pagination } from "./Pagination"

export class WhiteListSeller {
  public pagination?: Pagination
  public data?: WhiteSeller[]

  constructor(
    pagination?: Pagination,
    data?: WhiteSeller[]
  ) {
    this.pagination = pagination
    this.data = data
  }
}

export class WhiteSeller {
  public id?: number
  public name?: string
  public partnerPOS?: string
  public partnerCode?: string
  public phone?: string
  public role?: string
  public status?: string
  public partnerId?: number
  public codHandling?: string
  public createdAt?: string
  public createdBy?: string
  public updatedAt?: string
  public updatedBy?: string
  public courierId?: number | string
  public courierName?: string
  public assignType?: string
  public clientId?: number
  public clientName?: string
  public client?: string
  public address?: string
  public addressCount?: number

  constructor(
    id?: number,
    name?: string,
    partnerPOS?: string,
    partnerCode?: string,
    phone?: string,
    role?: string,
    status?: string,
    partnerId?: number,
    codHandling?: string,
    createdAt?: string,
    createdBy?: string,
    updatedAt?: string,
    updatedBy?: string,
    courierId?: number | string,
    courierName?: string,
    assignType?: string,
    clientId?: number,
    clientName?: string,
    client?: string,
    address?: string,
    addressCount?: number
  ) {
    this.id = id
    this.name = name
    this.partnerPOS = partnerPOS
    this.partnerCode = partnerCode
    this.phone = phone
    this.role = role
    this.status = status
    this.partnerId = partnerId
    this.codHandling = codHandling
    this.createdAt = createdAt
    this.createdBy = createdBy
    this.updatedAt = updatedAt
    this.updatedBy = updatedBy
    this.courierId = courierId
    this.courierName = courierName
    this.assignType = assignType
    this.clientId = clientId
    this.clientName = clientName
    this.client = client
    this.address = address
    this.addressCount = addressCount
  }
}

export class WhiteSellerPhone {
  phone = "";

  constructor(phone = "") {
    this.phone = phone;
  }
}

export class WhiteSellerCorporateClient {
  public clientId?: number
  public clientCode?: string
  public clientName?: string

  constructor(clientId?: number, clientCode?: string, clientName?: string) {
    this.clientId = clientId
    this.clientCode = clientCode
    this.clientName = clientName
  }
}

export class WhiteSellerPickupPoint {
  public pcaId?: number
  public pcaName?: string
  public pcaPicName?: string
  public pcaPhoneNumber?: string
  public pcaAddress?: string
  public pcaLatlon?: string

  constructor(
    pcaId?: number,
    pcaName?: string,
    pcaPicName?: string,
    pcaPhoneNumber?: string,
    pcaAddress?: string,
    pcaLatlon?: string
  ) {
    this.pcaId = pcaId
    this.pcaName = pcaName
    this.pcaPicName = pcaPicName
    this.pcaPhoneNumber = pcaPhoneNumber
    this.pcaAddress = pcaAddress
    this.pcaLatlon = pcaLatlon
  }
}

export class WhiteSellerBoundPickupPoints {
  public data: WhiteSellerPickupPoint[]
  public pagination: Pagination

  constructor(
    data: WhiteSellerPickupPoint[] = [],
    pagination: Pagination = new Pagination()
  ) {
    this.data = data
    this.pagination = pagination
  }
}
